export default "__VITE_ASSET__Dqh2HefZ__"